import React from 'react';

// ─── Design tokens (match App.js / GlobalCarePage) ───────────────────────────
const C = {
  navy:       '#1B2437',
  navyMid:    '#223049',
  orange:     '#F59420',
  white:      '#ffffff',
  off:        '#f8f9fa',
  border:     '#e5e7eb',
  textDark:   '#111827',
  text:       '#374151',
  muted:      '#6b7280',
  r:          '8px',
};

export default function PrivacyPage({ lang = 'es' }) {
  return (
    <div style={{ fontFamily: "'Inter', -apple-system, 'Segoe UI', sans-serif", color: C.text, background: C.white }}>
      {/* ════════════════════════════════════════════════════ HEADER */}
      <section style={{
        background: C.navy,
        padding: '80px 48px 56px',
      }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h1 style={{
            fontSize: 36, fontWeight: 800, color: C.white,
            letterSpacing: -1, lineHeight: 1.2,
          }}>
            Política de Tratamiento de Datos Personales
          </h1>
        </div>
      </section>

      {/* ════════════════════════════════════════════════════ CONTENT */}
      <section style={{ padding: '56px 48px 88px', background: C.white }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <p style={{ fontSize: 17, color: C.muted, lineHeight: 1.7 }}>
            Contenido de la política de privacidad — próximamente.
          </p>
        </div>
      </section>
    </div>
  );
}
